import { useQuery } from "@tanstack/react-query";
import axios from "../../axiosConfig";
import { GET_EMPLOYEE_ID } from "../queries/GetEmployeeDetails";

const fetchEmployeeId = async ({ queryKey }) => {
    const [, { token, accounts }] = queryKey;

    if (!token) throw new Error("Token not available");

    try {
        const response = await axios.get(`/GetEmployeeID/${accounts[0].username}`, {
            headers: {
              Authorization: token,
            },
          });
  

        return response.data;

    } catch (error) {
        throw new Error(error.response?.data || "Error fetching data");
    }
};

export const useGetEmployeeId = (params) => {
    return useQuery({
        queryKey: [GET_EMPLOYEE_ID, params],
        queryFn: fetchEmployeeId,
        enabled: !!params.token,
        retry: false,
    });
};